<app-card
  [class]="getClassName()"
  [elevation]="getElevation()"
  [clickable]="!pageView()"
  [padding]="'none'"
  [borderStyle]="cardBorderStyle"
  [borderRadius]="cardBorderRadius"
  [overflowVisible]="!pageView()"
  (clickEvent)="showDetailsClick()"
>
  @if (highlightCardAsActionNeeded) {
    <div
      [class]="baseClass + '__notification-bell'"
      (click)="notificationBellClick()"
    >
      <div [class]="'icon icon--bell'"></div>
    </div>
  }
  @if (!isRented()) {
    @if (showContextMenu) {
      <div
        im-dropdown
        position="block-end"
        [class]="getContextMenuClassName()"
        (click)="$event.stopPropagation()"
      >
        <button
          im-icon-button
          imDropdownTrigger
          [attr.aria-label]="'general.more_actions_a' | translate"
        >
          <i class="icon icon--context"></i>
        </button>
        <div imDropdownMenu>
          <div imDropdownGroup>
            @if (hasCustomQuestions()) {
              <button imDropdownItem (click)="answerCustomQuestionsClick()">
                <i class="icon icon--{{ 'question' }}"></i>
                {{ 'property.edit_custom_questions_a' | translate }}
              </button>
            }
            @if (hasDeniedIntention()) {
              <button imDropdownItem (click)="declareIntentClick()">
                <i class="icon icon--{{ 'check-framed' }}"></i>
                {{ 'property.declare_intent_a' | translate }}
              </button>
            }
            @if (hasDeclaredIntention()) {
              <button imDropdownItem (click)="denyIntentClick()">
                <i class="icon icon--{{ 'remove' }}"></i>
                {{ 'property.declare_no_intent_a' | translate }}
              </button>
            }
            <!-- TODO: replace attention icon with future 'no' icon and remove iconSpacing
          Before:
          <svg-icon
            [src]="'/assets/images/icons/icon-no.svg'"
            [applyClass]="true"
            [svgStyle]="{'width.px': 15}"
            class="negative-svg-color path rect circle"
          ></svg-icon>
          -->
            @if (enableExportAppointmentToCalendar()) {
              <button
                imDropdownItem
                (click)="exportAppointmentToCalendarClick()"
              >
                <i class="icon icon--{{ 'calendar' }}"></i>
                {{ 'property.export_appointment_to_calendar_a' | translate }}
              </button>
            }
            @if (enableDownloadPDF()) {
              <button imDropdownItem (click)="downloadPDFClick()">
                <i class="icon icon--{{ 'pdf' }}"></i>
                {{ 'property.export_pdf_a' | translate }}
              </button>
            }
            <button
              imDropdownItem
              (click)="removePropertyClick()"
              [disabled]="isProcessing()"
            >
              <i class="icon icon--{{ 'delete' }}"></i>
              {{
                (isProposal()
                  ? 'property.remove_property_proposal_a'
                  : 'property.remove_property_application_a'
                ) | translate
              }}
            </button>
            @if (isShowSelfDisclosure() && !isProposal() && isNotBlocked()) {
              <button
                imDropdownItem
                (click)="showSelfDisclosureClick()"
                [disabled]="isProcessing()"
              >
                <i class="icon icon--{{ 'attention' }}"></i>
                {{ 'self_disclosure.answers.open_dialog_menu_a' | translate }}
              </button>
            }
            @if (enableAppointmentSelection()) {
              <button imDropdownItem (click)="selectAppointmentClick()">
                <i class="icon icon--{{ 'calendar' }}"></i>
                {{ 'appointment.select_appointment_a' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    }
  } @else {
    @if (enableDownloadPDF()) {
      <button
        im-icon-button
        [class]="getDownloadPDFButtonClassName()"
        [attr.aria-label]="'general.download_a' | translate"
        (click)="downloadPDFClick()"
      >
        <i class="icon icon--download" aria-hidden="true"></i>
      </button>
    }
  }

  <div [class]="getBodyClassName()">
    <div [class]="baseClass + '__image-wrapper'">
      <app-image
        [class]="getImageClassName()"
        [defaultSrc]="
          hasImages
            ? images[0]?.url
            : '/assets/images/object-image-placeholder.svg'
        "
        alt="{{ hasImages && ('property.fallback_image_l' | translate) }}"
        (click)="showImageGalleryClick()"
      ></app-image>

      @if (showImageGallery) {
        <button
          im-button
          class="inverted"
          [class]="baseClass + '__lightbox-opener'"
          (click)="showImageGalleryClick()"
        >
          <i iconStart class="icon icon--gallery" aria-hidden="true"></i>
          {{ images.length }} {{ galleryButtonLabel }}
        </button>
      }
      @if (hasImages) {
        <div
          [class]="baseClass + '__image-background'"
          [style.background-image]="getBackgroundImage"
        ></div>
      }
    </div>
    @if (showApplicationStatusPipeline) {
      <app-application-status-pipeline
        class="d-block"
        [status]="applicationStatus()"
        [pageView]="pageView()"
        [propertyType]="propertyData()?.type"
      ></app-application-status-pipeline>
    }
    <div [class]="baseClass + '__content'" class="d-flex flex-column">
      <div
        [class]="baseClass + '__badges'"
        class="d-flex flex-row flex-wrap"
        [class.mb-3]="pageView()"
      >
        @if (propertyData().objectType || propertyData().type) {
          <im-chip class="dark">
            {{
              'FLATTYPES_' + (propertyData().objectType || propertyData().type)
                | translate
            }}
          </im-chip>
        }
        @if (propertyData().housingPermissionNeeded) {
          <im-chip class="primary">
            {{ 'property.wbs_badge_l' | translate }}
          </im-chip>
        }
        @if (actionBadgeContent()) {
          <im-chip class="negative"> {{ actionBadgeContent() }} </im-chip>
        }
        @if (highlightCardAsUserIsTenant) {
          <im-chip class="success">
            {{ 'general.congratulations_l' | translate }}
          </im-chip>
        }
        @if (hasUnansweredQuestions() && !isRented()) {
          <im-chip class="negative">
            {{ 'property.unanswered_questions_l' | translate }}
          </im-chip>
        }
        <!-- Slot for consumer-provided chips (e.g. SMS-verification badge, ART-17955) -->
        <ng-content select="[extraBadges]"></ng-content>
      </div>
      <div [class]="baseClass + '__details'">
        @if (
          showExternalId() && isNotNullAndUndefined(propertyData().externalId)
        ) {
          <div [class]="baseClass + '__external-id'" class="mb-1">
            {{ 'property.external_id_l' | translate }}
            {{ propertyData().externalId }}
          </div>
        }

        <!-- Name -->
        @if (pageView()) {
          <h1
            class="title-xl d-inline-block mb-0"
            [class]="baseClass + '__title'"
          >
            {{ propertyData().name }}
          </h1>
        } @else {
          <h2
            class="title-m d-inline-block mb-0"
            [class]="baseClass + '__title'"
          >
            {{ propertyData()?.name }}
          </h2>
        }
        @if (showAddress() || pageView()) {
          <span
            class="d-block mt-1"
            [class]="showAddress() && pageView() ? 'title-m' : 'title-s'"
          >
            @if (showAddress()) {
              {{ propertyData()?.address | appAddress }}
            } @else {
              {{ 'property.no_map_allowed_l' | translate }}
            }
          </span>
        }
      </div>
      @if (!pageView()) {
        <div class="mt-auto"></div>
      }
      @if (
        showAvailableFromDate() &&
        checkDateAndStringValidity(propertyData()?.availableFrom)
      ) {
        <div [class]="baseClass + '__available-from-date'" class="mt-3">
          {{ 'AVAILABLE_FROM_L' | translate }}
          <span class="ms-1">{{
            (propertyData()?.availableFrom?.dateAvailable | appDateTime) ||
              propertyData()?.availableFrom?.stringAvailable
          }}</span>
        </div>
      }
      @if (showLandlordInfo()) {
        <app-landlord-info
          [name]="landlordInfoData()?.name"
          [logo]="landlordInfoData()?.logo"
          [showInCooperationWith]="pageView()"
          [logoRedirectUrl]="
            pageView() ? landlordInfoData()?.logoRedirectUrl : null
          "
          [class.order-3]="pageView()"
          [class.mt-3]="!pageView()"
        ></app-landlord-info>
      }
      <hr [class.order-2]="pageView()" />
      <div
        [class]="baseClass + '__stats'"
        class="d-flex"
        [class.order-1]="pageView()"
        [class.mt-4]="pageView()"
      >
        <div [class]="baseClass + '__stats-left-group'">
          <!-- Room Size -->
          <div
            [class]="baseClass + '__stats-item'"
            class="d-flex align-items-center me-3"
          >
            <div [class]="'icon icon--area-size'"></div>
            {{ propertyData()?.size | number }} m<sup>2</sup>
          </div>

          <!-- Amount Rooms -->
          @if (propertyData()?.rooms) {
            <div
              [class]="baseClass + '__stats-item'"
              class="d-flex align-items-center me-3"
            >
              <div
                [class]="'icon icon--rooms'"
                [imTooltip]="
                  (propertyData()?.halfRooms ? 'NUMBER_OF_WHOLE_ROOMS' : '')
                    | translate
                "
              ></div>
              {{ propertyData()?.rooms | number }}
              @if (pageView()) {
                <span class="ms-1">
                  {{
                    (!propertyData()?.halfRooms
                      ? 'general.rooms_l'
                      : propertyData()?.rooms === 1
                        ? 'general.whole_room_l'
                        : 'general.whole_rooms_l'
                    ) | translate
                  }}
                </span>
              }
            </div>
          }

          <!-- Amount Half Rooms -->
          @if (propertyData()?.halfRooms) {
            <div
              [class]="baseClass + '__stats-item'"
              class="d-flex align-items-center"
            >
              <div
                [class]="'icon icon--half-rooms'"
                [imTooltip]="'NUMBER_OF_HALF_ROOMS_L' | translate"
              ></div>
              {{ propertyData()?.halfRooms | number }}
              @if (pageView()) {
                <span class="ms-1">
                  {{
                    (propertyData()?.halfRooms === 1
                      ? 'general.half_room_l'
                      : 'general.half_rooms_l'
                    ) | translate
                  }}
                </span>
              }
            </div>
          }
        </div>

        <!-- Price -->
        <div [class]="baseClass + '__stats-item'" class="my-0 ms-auto">
          @if (isRentalObject) {
            {{ propertyData()?.totalRentGross | currency: 'EUR' }}
            {{ 'general.monthly_short_l' | translate }}
          } @else {
            {{ propertyData()?.salesData?.price | currency: 'EUR' }}
          }
          @if (propertyData()?.commercialData?.vatNotIncludedInPrice) {
            {{ 'general.plus_vat_l' | translate }}
          }
          <!--          Implement and fix circular dependency: -->
          <!--          <app-property-price-or-rent-->
          <!--            [property]="propertyData()"-->
          <!--            [shortTranslation]="true"-->
          <!--          ></app-property-price-or-rent>-->
        </div>
      </div>
    </div>
  </div>
</app-card>
